// extracted by mini-css-extract-plugin
module.exports = {"fontHKGrotesk":"\"HK Grotesk\",sans-serif","fontSourceCourierNew":"source-code-pro,Menlo,Monaco,Consolas,\"Courier New\",monospace","fontSourceOpenSans":"\"Open Sans\",sans-serif"};